import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
const beliefs = [{
  title: 'Move fast, iterate often',
  description: 'Modern tools let us design and build quickly without cutting corners.'
}, {
  title: 'Specialist, not generalist',
  description: 'We go deep on eCommerce—especially wine, subscriptions, and Shopify.'
}, {
  title: "Build what's missing",
  description: "If a tool doesn't exist, we build it. That's why we have an Apps Division."
}];
export function About() {
  return <main className="flex-grow bg-[#F2F4F0]" data-id="element-82">
      {/* 1. HERO SECTION */}
      <section className="py-20 md:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center" data-id="element-83">
        <h1 className="text-5xl md:text-6xl font-serif font-semibold text-text mb-6" data-id="element-84">
          About CRU
        </h1>
        <p className="text-xl md:text-2xl text-muted font-sans max-w-3xl mx-auto" data-id="element-85">
          Melbourne-based eCommerce experts since 2011.
        </p>
      </section>

      {/* 2. OUR STORY SECTION */}
      <section className="py-16 md:py-24 bg-white" data-id="element-86">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
          <div className="max-w-3xl" data-id="element-88">
            <h2 className="text-3xl md:text-4xl font-serif font-semibold text-text mb-8" data-id="element-89">
              Our Story
            </h2>
            <div className="space-y-6 text-lg text-muted leading-relaxed" data-id="element-90">
              <p data-id="element-91">
                We've been building eCommerce websites for a long time. Our
                roots are in the wine industry, where we developed winery
                websites on WooCommerce and created CRU Club—one of Australia's
                first true choose-your-own wine club solutions.
              </p>
              <p data-id="element-92">
                At the time, this level of flexibility didn't exist. Members
                could choose their pack size, set their delivery frequency,
                unlock tiered discounts, and select or swap their wines before
                each shipment through their account. It was genuine
                build-your-own wine club functionality, years before it became
                the norm.
              </p>
              <p data-id="element-93">
                Wine has always been our home ground, though we've built across
                other industries too. For years, we ran both an agency and our
                own software, with CRU Club powering wine clubs across
                Australia.
              </p>
              <p data-id="element-94">
                But platforms evolve—and some fall behind. We began to see
                WooCommerce and its ecosystem struggling to keep pace with
                modern eCommerce. So we made a deliberate shift to help our
                clients future-proof their technology stack.
              </p>
              <p data-id="element-95">
                Today, that means Shopify as the core platform, combined with
                the best wine-specific technologies: Commerce7, WineHub, and
                WinePik (where we're the agency launch partner). We're also
                working with Naiomi AI to bring conversational analytics into
                Shopify stores.
              </p>
              <p data-id="element-96">
                What hasn't changed is our instinct to build. Alongside our
                agency work, our Apps Division identifies gaps in the ecosystems
                we operate in, builds fast with small teams, and delivers
                practical tools at a fraction of the cost of legacy industry
                software.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 3. HOW WE WORK SECTION */}
      <section className="py-16 md:py-24 bg-[#F2F4F0]" data-id="element-97">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-98">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-text mb-12" data-id="element-99">
            How We Work
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-100">
            {beliefs.map((belief, index) => <div key={index} className="bg-white p-8 rounded shadow-warm border border-border" data-id="element-101">
                <div className="flex items-start mb-4" data-id="element-102">
                  <span className="w-2 h-2 rounded-full bg-primary mt-2 mr-3 flex-shrink-0" data-id="element-103" />
                  <h3 className="text-xl font-serif font-semibold text-text" data-id="element-104">
                    {belief.title}
                  </h3>
                </div>
                <p className="text-muted leading-relaxed pl-5" data-id="element-105">
                  {belief.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 4. CTA SECTION */}
      <section className="py-24 px-4 sm:px-6 lg:px-8 text-center bg-[#F2F4F0]" data-id="element-106">
        <div className="max-w-3xl mx-auto space-y-8" data-id="element-107">
          <h2 className="text-4xl md:text-5xl font-serif font-semibold text-text" data-id="element-108">
            Want to work together?
          </h2>

          <p className="text-xl text-muted font-sans" data-id="element-109">
            Whether it's agency work or a custom app, we'd love to hear from
            you.
          </p>

          <div className="pt-4" data-id="element-110">
            <Link to="/contact" data-id="element-111">
              <Button size="lg" data-id="element-112">Get in Touch</Button>
            </Link>
          </div>
        </div>
      </section>
    </main>;
}